<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {pad0, formatDate, getDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CalendarNavigation from "./CalendarNavigation.svelte";
    import CalendarDay from "./CalendarDay.svelte";
    import Alert from "../stores/alerts";

    const weekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const pageHeaderControls = [
        {id: 'today', name: 'THIS MONTH'},
    ];

    // let date = null;
    let calendar = [];
    let calendarDate = null;
    let calendarMonth = 0;
    let calendarYear = 0;
    let today = getDate();

    const getDaysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    const stepMonth = (year, month, step) => {
        let m = month + step;
        let y = year;
        if (m > 12) {
            m = 1;
            y++;
        } else if (m < 1) {
            m = 12;
            y--;
        }

        return [y, m];
    }

    const setCalendar = () => {
        let monthDays = 0;
        let prevMonthDays = 0;
        calendar = [];

        monthDays = getDaysInMonth(calendarMonth, calendarYear);
        prevMonthDays = getDaysInMonth(calendarMonth - 1, calendarYear);
        let [previousYear, previousMonth] = stepMonth(calendarYear, calendarMonth, -1);
        let [nextYear, nextMonth] = stepMonth(calendarYear, calendarMonth, 1);

        let d = 0;
        let firstWeekDay = new Date(`${calendarYear}-${pad0(calendarMonth)}-01`).getDay() - 1; // 6 - Saturday
        if (firstWeekDay < 0) {
            firstWeekDay = 6;
        }
        // previous month
        d = prevMonthDays - firstWeekDay + 1;
        for (let index = 0; index < firstWeekDay; index++) {
            calendar.push({
                day: d,
                active: false,
                date: `${previousYear}-${pad0(previousMonth)}-${pad0(d)}`
            });
            d++;
        }
        // current month
        for (d = 1; d <= monthDays; d++) {
            calendar.push({
                day: d,
                active: true,
                date: `${calendarYear}-${pad0(calendarMonth)}-${pad0(d)}`
            });
        }
        // next month
        if (calendar.length % 7 > 0) {
            let daysToAdd = 7 - (calendar.length % 7);
            for (let d = 1; d <= daysToAdd; d++) {
                calendar.push({
                    day: d,
                    active: false,
                    date: `${nextYear}-${pad0(nextMonth)}-${pad0(d)}`
                });
            }
        }

        load();
    }

    const initialize = () => {
        let dt;
        // if (!date) {
        dt = new Date();

        // } else {
        //     dt = new Date(date);
        // }

        calendarMonth = dt.getMonth() + 1;
        calendarYear = dt.getFullYear();
        // calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;

        setCalendar();
    }

    const previousMonth = () => {
        calendarMonth--;
        if (calendarMonth < 1) {
            calendarYear--;
            calendarMonth = 12;
        }
        setCalendar();
    }

    const nextMonth = () => {
        calendarMonth++;
        if (calendarMonth > 12) {
            calendarYear++;
            calendarMonth = 1;
        }
        setCalendar();
    }

    const selectDate = (newDate) => {
        calendarDate = newDate;
        // date = newDate;
        router.go(`/app/calendar/${calendarDate}`)();
    }

    const load = (loader = LOADER.PAGE) => {
        const onSuccess = result => {
            calendar.map(day => {
                delete (day.total_persons);
            });

            result.reservations.map(item => {
                let cd = calendar.find(x => x.date === formatDate(item.date_at, 'y-m-d'));
                if (cd) {
                    if (!cd.total_persons) {
                        cd.total_persons = 0;
                    }
                    cd.total_persons += ~~item.persons;
                }
            });

            result.stop_sales.map(date => {
                let cd = calendar.find(x => x.date === date);
                if (cd) {
                    cd.stop_sales = true;
                }
            });

            calendar = calendar;
        }

        const onFailure = err => {
            let message = err.message ? err.message : "There was an error occurred while loading reservations.";
            Alert.warning("Calendar", message);
        };


        let data = {
            date_from: calendar[0].date,
            date_to: calendar[calendar.length - 1].date,
        }
        R.handle(R.reservation.monthSummary, data, onSuccess, onFailure, loader);
    }

    const dayChange = data => {
        load(LOADER.NONE);
    }

    const toggleStopSale = day => {
        console.log("toggle");
    }

    initialize();

    $: {
        today = getDate();
    }
</script>

<Route exact>
    <PageHeader title="Calendar" controls={ pageHeaderControls } on:today={ initialize }/>
    <CalendarNavigation title="{ months[calendarMonth - 1] } { calendarYear }"
                        on:click_previous="{ previousMonth }"
                        on:click_next="{ nextMonth }"/>

    <div class="calendar mb-4">
        {#each weekDays as wDay}
            <div class="weekday">
                { wDay }
            </div>
        {/each}
        {#each calendar as day}
            <button class="day" class:active={ day.active } class:selected="{ day.date === calendarDate }"
                    class:today={ day.date === today }
                    title="{day.total_persons ? `total persons: ${day.total_persons}/${$app.settings.max_cruise_persons}` : ''}"
                    on:click="{ () => selectDate(day.date) }">

                { day.day }
                {#if day.total_persons}
                    <span class="day-tours" class:is-full={day.total_persons >= $app.settings.max_cruise_persons - 2}>
                        {day.total_persons}
                    </span>
                {/if}
                <!--                <button class="btn-stop-sale" on:click|preventDefault|stopPropagation={() => toggleStopSale(day)}>-->
                <!--                    <AppIcon icon="stop-hand"/>-->
                <!--                </button>-->
                {#if day.stop_sales}
                    <!--                    <span class="stop-icon">-->
                    <!--                        <AppIcon icon="stop-hand"/>-->
                    <!--                    </span>-->
                    <span class="stop-icon">STOP<br>SALES</span>
                {/if}
            </button>
        {/each}
    </div>
</Route>
<Route match="*" let:router>
    <CalendarDay date="{ router.star }" callbackFunction={dayChange}/>
</Route>
<style>
    .calendar {
        color: #ababab;
        background: #fff;
        border: var(--default-border);
        border-radius: 3px;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        text-align: center;
        grid-gap: 1px;
        background: var(--default-border-color);
    }

    .calendar .weekday {
        letter-spacing: 1px;
        line-height: 1;
        color: #803384;
        background: #e4eaee;
        padding: 15px 0;
    }

    .calendar .day {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        font-size: 1.05rem;
        font-weight: 500;
        background: #f8fafb;
        border: unset;
        outline: none;
    }

    .calendar .day:hover {
        background: #eeeeee;
    }

    .calendar .day.active {
        color: #333333;
        background: #fff;
    }

    .calendar .day.today {
        background: #fff1c6;
    }

    .calendar .day.selected {
        background: #e4eaee;
    }

    .calendar .day .day-tours {
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        color: #fff;
        background: #8bc34a;
        padding: 5px 0;
        min-width: 30px;
        font-size: 0.8rem;
        font-weight: normal;
    }

    .calendar .day .day-tours.is-full {
        background: #e66465;
    }

    /*.btn-stop-sale {*/
    /*    position: absolute;*/
    /*    top: 0;*/
    /*    left: 0;*/
    /*    border: none;*/
    /*    background: #ff0000;*/
    /*    width: 30px;*/
    /*    height: 30px;*/
    /*    color: #fff;*/
    /*    outline: none;*/
    /*    display: flex;*/
    /*    justify-content: center;*/
    /*    align-items: center;*/
    /*    padding: 0;*/
    /*}*/

    /*.calendar .day.stop-sales {*/
    /*color: #fff;*/
    /*background: rgba(500, 0, 0, 0.5);*/
    /*}*/

    .calendar .day .stop-icon {
        /*position: absolute;*/
        /*top: 8px;*/
        /*right: 8px;*/
        /*color: #fff;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        font-weight: bold;
        letter-spacing: -1px;
        line-height: 1;
        opacity: 0.15;
    }

    @media (max-width: 576px) {
        .calendar .weekday {
            letter-spacing: unset;
        }

        .calendar .day {
            justify-content: flex-start;
            height: 60px;
            font-size: 1rem;
            font-weight: normal;
            padding: 0 0 0 8px;
        }

        .calendar .day .day-tours {
            min-width: 16px;
            font-size: 0.6rem;
            padding: 2px 3px;
        }

        .calendar .day .stop-icon {
            font-size: 14px;
        }
    }
</style>